import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { List, Map } from 'immutable';

import { EditableSection } from '®shared/reading-list/models';

import { ContainedTypeAndId, containerKey } from '../state';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'rl-view-container',
  templateUrl: './view-container.component.html',
})
export class ViewContainerComponent implements OnChanges {
  @Input() containerRoot: ContainedTypeAndId;
  @Input() containerStructure: Map<string, List<ContainedTypeAndId>>;
  @Input() entryVisibility: Map<string, boolean> | null;
  @Input() sectionsById: Map<string, EditableSection>;

  entries: List<ContainedTypeAndId>;

  ngOnChanges() {
    this.entries =
      this.containerRoot.type === 'lists'
        ? this.containerStructure.get(containerKey(this.containerRoot))
        : List([this.containerRoot]);
  }
}
